export const GET_DICTIONARY = "GET_DICTIONARY";
export const GET_DICTIONARY_SUCCESS = "GET_DICTIONARY_SUCCESS";
export const GET_DICTIONARY_FAIL = "GET_DICTIONARY_FAIL";
